import { useState } from "react";
import { useTranslation } from "react-i18next";
import "../../styles/mapStyles/SearchByLocation.css";

// ─────────────────────────────────────────────
// SearchByLocation
// Allows the user to type a location name and
// trigger a search. Tracks the input value and
// calls onSearch when the user submits.
//
// Props:
// - onSearch: function that receives the search query when the user submits
// - isLoading: disables the button while a
//   search is already in progress
// ─────────────────────────────────────────────

function SearchByLocation({ onSearch, isLoading }) {
  const { t } = useTranslation();
  // Tracks what the user is currently typing
  const [query, setQuery] = useState("");

  // This runs when the user presses Enter on the keyboard or taps the Search button.
  const handleSubmit = (e) => {
    // Prevent the browser's default form behavior so we stay in our React flow.
    e?.preventDefault();

    // Do nothing if the input is empty or just spaces
    if (!query.trim()) return;

    // Trigger the search with the trimmed query
    onSearch(query.trim());
  };

  return (
    <form
      className="search-bar-wrapper search-by-location"
      onSubmit={handleSubmit}
    >
      <div className="search-bar-input-row">

        {/* Text input — because this sits inside a form,
            pressing Enter on a desktop or phone keyboard now submits the search. */}
        <input
          type="text"
          className="search-bar-input"
          placeholder={t("search.searchLocationPlaceholder")}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          enterKeyHint="search"
          disabled={isLoading} // disabled while a search is in progress
        />

        {/* Search button — triggers the search */}
        <button
          type="submit"
          className="search-bar-btn"
          disabled={isLoading || !query.trim()} // disabled if loading or input is empty
        >
          {isLoading ? t("common.searching") : t("common.search")}
        </button>

      </div>
    </form>
  );
}

export default SearchByLocation;
